import { render, staticRenderFns } from "./FormItemOuts.vue?vue&type=template&id=2a945b22"
import script from "./FormItemOuts.vue?vue&type=script&lang=js"
export * from "./FormItemOuts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports